import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { cn } from '@/lib/core';
import type { HeroSlide } from '@/lib/core/utils';

export function ShopProductListHeroCarousel({ slides }: { slides: HeroSlide[] }) {
  const [activeIndex, setActiveIndex] = useState(0);

  if (slides.length === 0) return null;

  return (
    <div className="relative h-156 w-full shrink-0">
      <Swiper
        className="h-full"
        slidesPerView={1}
        onActiveIndexChange={swiper => setActiveIndex(swiper.activeIndex)}
      >
        {slides.map(slide => (
          <SwiperSlide key={slide.id}>
            <div
              className="bg-jncquoi-neutral-1000 relative h-full w-full"
              style={
                slide.image
                  ? {
                      backgroundImage: `url(${slide.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }
                  : undefined
              }
            >
              <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-0"
                style={{
                  background:
                    'linear-gradient(to bottom, rgba(0,0,0,0.8) 1%, rgba(0,0,0,0.2) 22%, rgba(0,0,0,0.1) 56%, rgba(0,0,0,1) 79%)',
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="pointer-events-none absolute right-4 bottom-10 left-4 z-10 flex flex-col gap-8">
        {(slides[activeIndex]?.eyebrow || slides[activeIndex]?.headline) && (
          <div className="flex flex-col gap-6">
            {slides[activeIndex].eyebrow && (
              <p className="font-pp-neue-montreal text-[12px] font-normal tracking-[0.5px] text-white uppercase">
                {slides[activeIndex].eyebrow}
              </p>
            )}
            {slides[activeIndex].headline && (
              <p className="font-pp-neue-montreal text-[28px] leading-tight font-semibold tracking-[0.5px] text-white uppercase">
                {slides[activeIndex].headline}
              </p>
            )}
          </div>
        )}
        {slides.length > 1 && (
          <div className="flex items-center gap-2" aria-hidden="true">
            {slides.map((_, i) => (
              <span
                key={i}
                className={cn(
                  'block h-px w-4 transition-all duration-300',
                  i === activeIndex ? 'bg-white' : 'bg-white/40'
                )}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
